import './App.css';
import React, { useEffect } from 'react';
import {BrowserRouter, Routes, Route, useLocation} from "react-router-dom";

import Layout from "./pages/Layout";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import NewsAnnouncements from './pages/NewsAnnouncements';
import Events from './pages/Events';
import Rental from './pages/Rental';
import Gallery from './pages/Gallery';
import Advertise from './pages/Advertise';
import Memberships from './pages/Memberships';
import Contact from './pages/Contact';
import Donate from './pages/Donate';
import Report from './pages/Finance';
import Constitution from './pages/Constitution';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const hash = window.location.hash;
    if(!hash){
      requestAnimationFrame(() => {
          window.scrollTo(0, 0);
      });
    }
  }, [pathname]);
  return null;
};

export default function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="aboutus" element={<AboutUs/>} />
          <Route path="news" element={<NewsAnnouncements/>} />
          <Route path="events" element={<Events/>} />
          <Route path="spaces" element={<Rental/>} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="advertise" element={<Advertise/>} />
          <Route path="memberships" element={<Memberships/>} />
          <Route path="contact" element={<Contact/>} />
          <Route path="donate" element={<Donate/>} />
          <Route path="report" element={<Report/>} />
          <Route path="constitution" element={<Constitution/>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}